import React from 'react';
import styles from './RankRow.module.scss';
import { renderMaxLengthText } from 'utils/renderMaxLengthText';

export const RankRow = ({ rank, name, statValue, country, countryCode, flagUrl, photoUrl, showCountryName }) => (
  <div className={styles.row}>
    <div className={styles.rankBadge}>
      <div className={styles.rankNumberWrap}>
        <span className={styles.rankNumber}>{rank}</span>
      </div>
    </div>

    <div className={styles.photoStrip}>
      {photoUrl && (
        <img src={photoUrl} alt={name} className={styles.photo} />
      )}
    </div>

    <div className={styles.infoPill}>
      <span className={styles.name}>{renderMaxLengthText(name, 21)}</span>
      <span className={styles.value}>{statValue ?? '0000'}</span>
      <div className={`${styles.countryRow}${showCountryName ? ` ${styles['countryRow--named']}` : ''}`}>
        {flagUrl && (
          <div className={styles.flagWrap}>
            <img src={flagUrl} alt={country} className={styles.flagImg} />
          </div>
        )}
        <span className={styles.countryName}>
          {showCountryName ? renderMaxLengthText(country, 15) : countryCode}
        </span>
      </div>
    </div>
  </div>
);
